<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actCatMain">
          <v-card id="actCatCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.rankList") }}</v-card-title>
            <v-data-table id="actCatTable" :headers="headers" :items="items" :items-per-page="-1" :sort-by="['activityCategoryCode']" :sort-desc="[false]" class="elevation-0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: center">{{ props.item.ranking }}</td>
                  <td style="text-align: left">{{ props.item.rankCode }}</td>
                  <td style="text-align: left">{{ props.item.isDeleted }}</td>
                  <td style="text-align: center">
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)"> <v-icon small color="primary">mdi-delete</v-icon> </v-btn>&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="showDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field class="form-control" v-model="editedItem.ranking" :rules="[() => !!editedItem.ranking || requiredMessage]" required>
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.ranking") }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field class="form-control" v-model="editedItem.rankCode" :rules="[() => !!editedItem.rankCode || requiredMessage]" required>
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.rankCode") }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-btn id="btnAddactCat" color="primary" dark small left fab @click="createItem()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn class="ml-5" color="primary" @click="dialogImport = !dialogImport">
                <span class="text-caption">{{ $t("common.importFile") }}</span>
                <v-icon class="ml-3">mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn class="ml-5" color="success" :href="exportExcel()" @click="mShowInfoMessage('Excel export requested')">
                <span class="text-caption">{{ $t("common.exportFile") }}</span>
                <v-icon class="ml-3">mdi-download</v-icon>
              </v-btn>
            </v-card-actions>

            <v-dialog v-model="dialogImport" persistent width="500">
              <v-card>
                <v-card-title
                  ><span class="headline">{{ $t("common.importFile") }}</span></v-card-title
                >

                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-file-input v-model="file" accept=".xlsx" prepend-icon="mdi-microsoft-excel" label="Choose file to import" class="ma-2" @change="onFilePicked"></v-file-input>
                      <span v-if="showError" style="color: red">{{ $t("common.fileformaterror") }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-checkbox class="ml-3" v-model="emptyFolder">
                        <template v-slot:label>
                          {{ $t("common.emptyFolder") }}
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="warning" text @click="dialogImport = !dialogImport">{{ $t("common.cancel") }}</v-btn>

                  <v-btn color="primary" text :disabled="canUpload" @click="actionUpload()">{{ $t("common.import") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import store from "@/store/";
import Vue from "vue";

export default {
  data() {
    return {
      showDialog: false,
      requiredMessage: this.$t("common.required"),
      headers: [
        {
          text: this.$t("column.ranking"),
          align: "center",
          sortable: true,
          value: "ranking",
          width: "15%",
        },
        {
          text: this.$t("column.rankCode"),
          align: "left",
          value: "rankCode",
        },
        {
          text: this.$t("column.isDeleted"),
          align: "left",
          value: "isDeleted",
        },
        {
          text: this.$t("column.actions"),
          align: "center",
          value: "actCatactions",
          sortable: false,
          width: "20%",
        },
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      dialogImport: false,
      showError: false,
      file: null,
      emptyFolder: false,
      selectedPvId: null,
      importDlg: {
        projectId: null,
        vesselId: null,
      },
      excellink: "rank/export",
    };
  },
  computed: {
    ...mapGetters(["m_ranklist/getRanklist", "m_actCat/getNextSeqCode", "m_actCat/getActivityCategories"]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("nav.rankList") : this.$t("common.edit") + " " + this.$t("nav.rankList");
    },

    items() {
      return this["m_ranklist/getRanklist"];
    },

    formIsValid() {
      return this.editedItem.ranking && this.editedItem.rankCode;
    },

    canUpload() {
      return !this.file && !this.showError && !this.selectedPrj && !this.selectedVessel;
    },
  },
  watch: {
    showDialog(val) {
      val || this.close();
    },
  },

  created() {},

  methods: {
    ...mapMutations(["mHideLongLoader", "mShowInfoMessage"]),
    ...mapActions(["m_ranklist/fetchRankList", "m_ranklist/deleteRankList", "m_ranklist/updateRankList", "m_ranklist/createRankList", "m_ranklist/updateRanklistList"]),

    async refreshRankList() {
      await this["m_ranklist/fetchRankList"]();
    },

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1;
      this.editedItem = Object.assign({}, item || this.defaultItem);
    },

    editItem(item) {
      this.resetEntity(item);
      this.showDialog = true;
    },

    createItem() {
      this.resetEntity();
      this.showDialog = true;
    },

    deleteItemConfirm(item) {
      this.resetEntity(item);

      var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";

      this.$confirm(this.$t(msg) + this.$t("nav.rankList") + "?", {
        buttonTrueText: this.$t("common.delete"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => res && this["m_ranklist/deleteRankList"](this.editedItem).then(this.refreshRankList));
    },
    close() {
      this.$refs.form.resetValidation();
      this.showDialog = false;
    },

    save() {
      if (~this.editedIndex) {
        this["m_ranklist/updateRankList"](this.editedItem).then(this.refreshRankList);
      }

      if (!~this.editedIndex) {
        this["m_ranklist/createRankList"](this.editedItem).then(this.refreshRankList);
      }

      this.close();
    },

    onFilePicked() {
      this.$log.debug(this.file);
      let sp = this.file.name.split(".");
      if (this.file) {
        if (sp[1] != "xlsx") {
          this.showError = true;
        } else this.showError = false;
      }
    },

    exportExcel() {
      if (this.excellink) return Vue.$href(this.excellink);
      return undefined;
    },

    async actionUpload() {
      let payload = {
        file: this.file,
        resetOldValues: this.emptyFolder,
      };

      await this["m_ranklist/updateRanklistList"](payload)
        .then(this.refreshRankList)
        .then((this.dialogImport = false));
    },
  },

  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await store.dispatch("m_ranklist/fetchRankList");
      vm.mHideLongLoader();
    });
  },
};
</script>

<style>
#actCatTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#actCatTable header {
  font-weight: bold;
}
#actCatCard {
  width: auto;
}
</style>
